// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 品牌信息 */
export type Brand = {
  id?: number;
  brandName?: string;
  contactName?: string;
  contactPhone?: string;
  status?: number;
  createdAt?: number;
  updatedAt?: number;
  adminPhone?: string;
  adminPassword?: string;
};

/** 品牌列表参数 */
export type BrandListParams = {
  page?: number;
  pageSize?: number;
  brandName?: string;
  status?: number;
};

/** 分页响应 */
export type PageResult<T> = {
  list?: T[];
  total?: number;
  page?: number;
  pageSize?: number;
};

/** 通用响应 */
export type Result<T = any> = {
  code?: number;
  message?: string;
  data?: T;
  timestamp?: number;
};

/**
 * 获取品牌列表
 * GET /api/brands
 */
export async function getBrandList(
  params: BrandListParams,
  options?: { [key: string]: any },
) {
  return request<Result<PageResult<Brand>>>('/api/brands', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
